

  export let filterUndefined = (obj) => {

    return obj !== (undefined || null)

  }

  let allKeywordsMatch = (icon, keywords) => {

    let iconKeywords = [for (iconKeyword of icon.keywords) iconKeyword.toLowerCase()]

    let isSubgroup = keywords.every(function(val){
      return (iconKeywords.indexOf(val.toLowerCase()) >= 0) ? icon: undefined
    })

    return isSubgroup ? icon : undefined

  }

  let keywordFilteredSubpack = (subpack, keywords) =>{

    subpack.icons = subpack.icons.map((i) => allKeywordsMatch(i, keywords))

    subpack.icons = JSON.parse(JSON.stringify(subpack.icons)).filter(filterUndefined)

    return (subpack.icons.length > 0) ? subpack : undefined
  }

  export let keywordFilteredPack = (pack, keywords) => {
    if (!keywords.map(key => key.toLowerCase()).includes(pack.name.toLowerCase())){
      pack.subpacks = pack.subpacks.map((sp) => keywordFilteredSubpack(sp, keywords))
      pack.subpacks = JSON.parse(JSON.stringify(pack.subpacks)).filter(filterUndefined)
    }

    return (pack.subpacks.length > 0) ? pack : undefined

  }



// WEBPACK FOOTER //
// ./src/js/toolbar/filters.js